export enum DegreeOfFreedom {
  'Surge',
  'Sway',
  'Heave',
  'Roll',
  'Pitch',
  'Yaw',
}
